var map = {
	"./amulet_1.png": "1a83",
	"./amulet_2.png": "384b",
	"./amulet_3.png": "8670",
	"./amulet_4.png": "a01b",
	"./amulet_5.png": "0e01",
	"./amulet_6.png": "ee4d",
	"./belt_1.png": "c087",
	"./belt_10.png": "a426",
	"./belt_11.png": "b371",
	"./belt_12.png": "7238",
	"./belt_2.png": "926b",
	"./belt_3.png": "b1df",
	"./belt_4.png": "d9e3",
	"./belt_5.png": "5038",
	"./belt_6.png": "2fcb",
	"./belt_7.png": "6d93",
	"./belt_8.png": "5ae2",
	"./belt_9.png": "28ec",
	"./book_1.png": "57be",
	"./book_2.png": "c217",
	"./book_3.png": "98d1",
	"./book_4.png": "4ca7",
	"./book_5.png": "d797",
	"./boots_1.png": "137f",
	"./boots_10.png": "6879",
	"./boots_11.png": "c32e",
	"./boots_12.png": "1025",
	"./boots_2.png": "0210",
	"./boots_3.png": "6582",
	"./boots_4.png": "cb8f",
	"./boots_5.png": "6aa1",
	"./boots_6.png": "6205",
	"./boots_7.png": "232b",
	"./boots_8.png": "ca9d",
	"./boots_9.png": "62cb",
	"./bracers_1.png": "6b9a",
	"./bracers_10.png": "262a",
	"./bracers_11.png": "5d8c",
	"./bracers_12.png": "5431",
	"./bracers_13.png": "3253",
	"./bracers_14.png": "b887",
	"./bracers_15.png": "7c31",
	"./bracers_16.png": "0ccf",
	"./bracers_17.png": "a4bf",
	"./bracers_18.png": "e710",
	"./bracers_19.png": "909f",
	"./bracers_2.png": "3b44",
	"./bracers_3.png": "3254",
	"./bracers_4.png": "cbfb",
	"./bracers_5.png": "db62",
	"./bracers_6.png": "af14",
	"./bracers_7.png": "0f41",
	"./bracers_8.png": "5d2e",
	"./bracers_9.png": "1a29",
	"./cloak_1.png": "0198",
	"./cloak_2.png": "ee7a",
	"./cloak_3.png": "a679",
	"./cloak_4.png": "261c",
	"./compass_1.png": "4a11",
	"./cowl_1.png": "d8e6",
	"./flute_1.png": "0c04",
	"./gauntlets_1.png": "6865",
	"./gauntlets_2.png": "0fb2",
	"./gauntlets_3.png": "b9c5",
	"./gauntlets_4.png": "adb9",
	"./gem.png": "1698",
	"./gem_1.png": "acd3",
	"./hat_1.png": "094c",
	"./hat_2.png": "86d7",
	"./headdress_1.png": "aeae",
	"./helmet_1.png": "1dff",
	"./helmet_2.png": "1ee4",
	"./helmet_3.png": "19de",
	"./helmet_4.png": "edfd",
	"./helmet_5.png": "0b76",
	"./helmet_6.png": "5f54",
	"./hood_1.png": "ecb5",
	"./incense_1.png": "2937",
	"./mask_1.png": "0463",
	"./mirror_1.png": "41b2",
	"./mirror_2.png": "99b0",
	"./tattoo_1.png": "adf5",
	"./tattoo_2.png": "3462",
	"./tattoo_3.png": "15b4",
	"./tattoo_4.png": "7757",
	"./tattoo_5.png": "853d",
	"./tattoo_6.png": "6e11",
	"./tattoo_7.png": "98c3",
	"./tattoo_8.png": "0c4f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "334a";